import SuppliersSelectedModal from '@/components/_common/SuppliersSelectedModal';
import { useDisclosure } from '@/hooks';
import { Badge, Button, Col, Collapse, FormInstance, Space } from 'antd';
import { useIntl } from 'react-intl';
import { useState } from 'react';
import { Supplier } from '@/core/domain/people/Suppliers/Suppliers.types';
import DocumentTypesSelectedModal from '@/components/_common/DocumentTypesSelectedModal';
import { DocumentType } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.types';
import CfopSelectModal from '@/components/_common/CfopSelectModal';
import WorkOrderSelectModal from '@/components/_common/WorkOrderSelectModal';

const PurchasesMoreOptions: React.FC<{ form: FormInstance }> = ({ form }) => {
  const { Panel } = Collapse;
  const intl = useIntl();
  const [supplierVisible, setSupplierVisible] = useDisclosure();
  const [supplierId, setSupplierId] = useState<number[]>();
  const [documentTypeVisible, setDocumentTypeVisible] = useDisclosure();
  const [documentTypeId, setDocumentTypeId] = useState<number[]>();
  const [cfopVisible, setCfopVisible] = useDisclosure();
  const [cfopId, setCfopId] = useState<number[]>();
  const [workOrderVisible, setWorkOrderVisible] = useDisclosure();
  const [workOrderId, setWorkOrderId] = useState<number[]>();

  return (
    <Col sm={24}>
      <Collapse accordion>
        <Panel
          header={intl.formatMessage({
            id: 'purchasesPurchaseReport.form.moreOptions',
          })}
          key={1}
        >
          <Col span={3}>
            <Space size="large">
              <Badge count={supplierId?.length}>
                <Button type="primary" onClick={setSupplierVisible.open}>
                  {intl.formatMessage({
                    id: 'purchasesPurchaseReport.form.moreOptions.button.selectSuppliers',
                  })}
                </Button>
              </Badge>
              <Badge count={documentTypeId?.length}>
                <Button type="primary" onClick={setDocumentTypeVisible.open}>
                  {intl.formatMessage({
                    id: 'purchasesPurchaseReport.form.moreOptions.button.selectDocumentType',
                  })}
                </Button>
              </Badge>
              <Badge count={cfopId?.length}>
                <Button type="primary" onClick={setCfopVisible.open}>
                  {intl.formatMessage({
                    id: 'purchasesPurchaseReport.form.moreOptions.button.selectCfop',
                  })}
                </Button>
              </Badge>
              <Badge count={workOrderId?.length}>
                <Button type="primary" onClick={setWorkOrderVisible.open}>
                  {intl.formatMessage({
                    id: 'purchasesPurchaseReport.form.moreOptions.button.selectWorkOrder',
                  })}
                </Button>
              </Badge>
            </Space>
          </Col>
        </Panel>
      </Collapse>
      <SuppliersSelectedModal
        handleVisible={setSupplierVisible.close}
        visible={supplierVisible}
        finishCallback={(suppliers) => {
          setSupplierId(suppliers);
          form.setFieldValue('suppliersIds', suppliers);
        }}
        selectedSuppliers={
          supplierId?.map((cur) => ({ id: cur })) as unknown as Supplier[]
        }
      />
      <DocumentTypesSelectedModal
        handleVisible={setDocumentTypeVisible.close}
        visible={documentTypeVisible}
        finishCallback={(documentType) => {
          setDocumentTypeId(documentType?.map(({ id }) => id));
          form.setFieldValue(
            'documentTypeIds',
            documentType?.map(({ id }) => id),
          );
        }}
        selectedDocumentTypes={
          documentTypeId?.map((cur) => ({
            id: cur,
          })) as unknown as DocumentType[]
        }
      />
      <CfopSelectModal
        visible={cfopVisible}
        handleVisible={setCfopVisible.close}
        finishCallback={(cfop) => {
          setCfopId(cfop?.map(({ id }) => id));
          form.setFieldValue(
            'cfopIds',
            cfop?.map(({ id }) => id),
          );
        }}
        selectedCfop={cfopId}
      />
      <WorkOrderSelectModal
        visible={workOrderVisible}
        handleVisible={setWorkOrderVisible.close}
        finishCallback={(workorder) => {
          setWorkOrderId(workorder?.map(({ complementId }) => complementId));
          form.setFieldValue(
            'workOrderComplementIds',
            workorder?.map(({ complementId }) => complementId),
          );
        }}
        selectedWorkOrder={workOrderId}
      />
    </Col>
  );
};

export default PurchasesMoreOptions;
